export default [
    {
        path: '/',
        name: 'dashboard',
        component: () => import('@/views/dashboard/index2.vue'),
        meta: {
            layout: 'full',
        },
    },
]